import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, X } from 'lucide-react';
const buyers = [{
  name: 'Marco',
  city: 'Roma'
}, {
  name: 'Giuseppe',
  city: 'Napoli'
}, {
  name: 'Alessandro',
  city: 'Milano'
}, {
  name: 'Francesco',
  city: 'Torino'
}, {
  name: 'Lorenzo',
  city: 'Firenze'
}, {
  name: 'Matteo',
  city: 'Bologna'
}, {
  name: 'Andrea',
  city: 'Palermo'
}, {
  name: 'Gabriele',
  city: 'Genova'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const interval = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-158">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-lg shadow-xl border border-gray-100 p-4 z-50 flex items-start gap-3" data-id="element-159">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0" data-id="element-160">
            <span className="text-blue-600 font-bold text-lg" data-id="element-161">
              {buyer.name.charAt(0)}
            </span>
          </div>
          <div className="flex-1" data-id="element-162">
            <p className="text-sm text-gray-800" data-id="element-163">
              <span className="font-bold" data-id="element-164">{buyer.name}</span> ha appena
              acquistato
            </p>
            <p className="text-xs text-blue-600 font-semibold mb-1" data-id="element-165">
              Padel 360 Senza Infortuni
            </p>
            <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-166">
              <MapPin className="w-3 h-3" data-id="element-167" /> da {buyer.city}, Italia
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" data-id="element-168">
            <X className="w-4 h-4" data-id="element-169" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}